import { ActivityComponentType } from '@stackflow/react'
import { useQueries } from '@tanstack/react-query'
import { useRouter } from 'next/router'
import { fetchMainPost, fetchMenu, fetchPosts, fetchSubMenu } from '../../../pages/[lang]/student/landing/blog'
import { useBlogStack } from '../../../pages/[lang]/webview/blog'
import BlogHomeMobile from '../../landing/blog/BlogHomeMobile'
import WebviewStackContainer from '../common/WebviewStackContainer'

const BlogMainAcitivity: ActivityComponentType = () => {
  const router = useRouter()
  const { useBlogFlow } = useBlogStack()
  const { pop } = useBlogFlow()
  const lang = router.query.lang

  // 병렬로 쿼리를 실행합니다.
  const queryResults = useQueries({
    queries: [
      {
        queryKey: ['posts', lang],
        queryFn: () => fetchPosts(lang),
        enabled: !!lang, // lang 값이 존재할 때만 쿼리 실행
      },
      {
        queryKey: ['menu', lang],
        queryFn: () => fetchMenu(lang),
        enabled: !!lang,
      },
      {
        queryKey: ['subMenu', lang],
        queryFn: () => fetchSubMenu(),
        enabled: !!lang,
      },
      {
        queryKey: ['mainPost', lang],
        queryFn: () => fetchMainPost(lang),
        enabled: !!lang,
      },
    ],
  })

  const isFetching = queryResults.some((query) => query.isFetching)

  const [postsResult, menuResult, subMenuResult, mainPostResult] = queryResults

  const { data: posts } = postsResult
  const { data: menu } = menuResult
  const { data: subMenu } = subMenuResult
  const { data: mainPostData } = mainPostResult

  return (
    <WebviewStackContainer height="52px" onBack={pop}>
      {!isFetching && (
        <BlogHomeMobile
          mainPost={mainPostData}
          posts={posts}
          menu={menu}
          subMenu={subMenu}
          isWebviewInitialValue={true}
        />
      )}
    </WebviewStackContainer>
  )
}

export default BlogMainAcitivity
